module.exports = __webpack_public_path__ + "static/media/Relative-Book-Web.727a3824.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Relative-Book-Web.ttf
// module id = 738
// module chunks = 0